import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { ChartBarIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { ArCashMetricsRangeSchema } from '@erp/rpc';
import { Route as pathlessAuthenticatedRoute } from '../../route';
import { requireAnyPermission, requireModules } from '../../route';

const ARCashMetricsPage = lazyRouteComponent(() =>
  import('./ARCashMetricsPage').then((module) => ({
    default: module.ARCashMetricsPage,
  })),
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/accounts-receivable/cash-metrics',
  staticData: {
    app: {
      nav: {
        label: msg('Cash Metrics', {
          context: 'sidebar nav label, Accounts Receivable section',
        }),
        icon: <ChartBarIcon className="h-4 w-4" weight="fill" />,
        group: 'Accounts Receivable',
        order: 12,
      },
      access: {
        modulesAnyOf: [ProductModule.AR_INVOICING],
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.ARCash }],
      },
    },
  },
  component: ARCashMetricsPage,
  loader: () => ({
    crumb: msg('Cash Metrics', { context: 'page breadcrumb' }),
  }),
  validateSearch: z.object({
    range: ArCashMetricsRangeSchema.optional().catch(undefined),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({ context, oneOf: [ProductModule.AR_INVOICING] });
    await requireAnyPermission({
      context,
      permissions: [{ action: Action.Read, subject: Subject.ARCash }],
    });
  },
});
